import {API_URL} from '@/common/config';

// Login
export const LOGIN_URL = `/api/internal/assettracker/token`;

// Settings
export const SETTINGS_URL = `${API_URL}/settings`;

// Devices
export const CREATE_DEVICE_URL = `${API_URL}/devices`;
export const FETCH_DEVICES_URL = `${API_URL}/devices`;
export const UPDATE_SINGLE_DEVICE_URL = `${API_URL}/devices`;
export const FETCH_SINGLE_DEVICE_URL = `${API_URL}/devices/device`;
export const DELETE_DEVICE_URL = `${API_URL}/devices/:deviceId`;
export const UPDATE_REFRESH_RATE_URL = `${API_URL}/devices/:deviceId/refresh-rate/:value`;
export const GET_MOVE_DETAILS = `${API_URL}/moves/:id`;
export const FETCH_DEVICE_USAGE_URL = `${API_URL}/devices/usage`;

// Moves
export const FETCH_MOVES_URL = `${API_URL}/moves`;
export const ASSIGN_DEVICE_TO_MOVE_URL = `${API_URL}/moves/:moveId/device/:deviceId`;
export const REMOVE_ASSIGNED_DEVICE_URL = `${API_URL}/moves/:moveId/remove-device`;

// Notifications
export const FETCH_NOTIFICATIONS_URL = `${API_URL}/notifications`;
export const CHANGE_NOTIFICATIONS_READ_STATUS_URL = `${API_URL}/notifications/:id/read-status`;
export const GET_NOT_READ_NOTIFICATIONS_COUNT_URL = `${API_URL}/notifications/not-read-count`;

